/**
 * Load the ressources for the app.
 */
import _ from "lodash";
import axios from "axios";
import { JSONLDSource, PageSource } from "./sources";
import { PageAction, LoadAction } from "./actions";
import { List } from "immutable";
import * as Models from "./models";

if (process.env.NODE_ENV === "development") {
  // Development axios conf
  axios.defaults.baseURL = "http://localhost:3000";
}
// Configure default for axios.
axios.defaults.timeout = false;
axios.defaults.responseType = "json";
axios.defaults.headers = { "X-Requested-With": "XMLHttpRequest" };

const recursivePageFetch = (retry = 0) => {
  return PageSource.fetch()
    .then((data) => {
      if (!("themeHref" in data)) {
        return recursivePageFetch(retry + 1);
      }
      return data;
    })
    .catch((error) => {
      if (retry < 100) {
        return recursivePageFetch(retry + 1);
      }
      throw error;
    });
};

export default function loadMetadatas() {
  LoadAction.addProcess();
  return JSONLDSource.fetch()
    .then((parsedGraph) => {
      // JSONLD loaded and parsed in a snapshot-ready object.
      return recursivePageFetch().then((pageJSON) => {
        parsedGraph.themeHref = pageJSON.themeHref;
        parsedGraph.FacebookURL = pageJSON.FacebookURL;
        parsedGraph.InstagramURL = pageJSON.InstagramURL;
        parsedGraph.LinkedinURL = pageJSON.LinkedinURL;
        parsedGraph.navShortcuts = new List(
          pageJSON.navShortcuts.map((button) => {
            return new Models.NavItem(button);
          })
        );

        parsedGraph.pages = {};
        // Parse the API.
        _.forEach(pageJSON.pages, (page) => {
          page.ShowInMenus = page.ShowInMenus === 1;
          parsedGraph.navigation = parsedGraph.navigation.map((navItem) => {
            if (navItem.url === page.Path) {
              if (page._embedded && page._embedded.IconLink) {
                navItem = navItem.set("Icon", page._embedded.IconLink);
              }
              return navItem.set("ShowInMenus", page.ShowInMenus);
            }
            return navItem;
          });
          if (!_.has(parsedGraph.pages, page["@type"])) {
            parsedGraph.pages[page["@type"]] = new List();
          }
          if (!_.has(Models, page["@type"])) {
            throw new Error("Model " + page["@type"] + " missing");
          }
          const model = new Models[page["@type"]](page);
          parsedGraph.pages[page["@type"]] = parsedGraph.pages[
            page["@type"]
          ].push(model);
        });
        return Promise.resolve(parsedGraph);
      });
    })
    .then((storeSnapshot) => {
      PageAction.init(storeSnapshot);
      return Promise.resolve();
    })
    .then(LoadAction.removeProcess);
}



// WEBPACK FOOTER //
// ./src/loadApp.js